import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";

// COMPONENTS
import { ChatComponent } from "./components/chat/chat.component";

// ALL TIME REQUIRED
import { AdminLayoutComponent } from "./components/layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./components/layouts/auth-layout/auth-layout.component";

// DIRECTIVES
import { FontSizeDirective } from "./directives/font-size.directive";
import { ScrollToDirective } from "./directives/scroll-to.directive";
import { AppDropdownDirective } from "./directives/dropdown.directive";
import { DropdownAnchorDirective } from "./directives/dropdown-anchor.directive";
import { DropdownLinkDirective } from "./directives/dropdown-link.directive";

// PIPES
import { RelativeTimePipe } from "./pipes/relative-time.pipe";
import { ExcerptPipe } from "./pipes/excerpt.pipe";

// SERVICES
import { ThemeService } from "./services/theme.service";
import { LayoutService } from "./services/layout.service";
import { NavigationService } from "./services/navigation.service";
import { RoutePartsService } from "./services/route-parts.service";
import { AuthGuard } from "./services/auth/auth.guard";
import { AppLoaderModule } from "./services/app-loader/app-loader.module";
import { AppConfirmModule } from "./services/app-confirm/app-confirm.module";
import { PainelService } from "./services/painel.service";
import { AuthContractsModule } from "./services/auth-contracts/auth-contracts.module";
import { ContractsComponent } from "./components/contracts/contracts.component";
import { HeaderTopComponent } from "./components/header-top/header-top.component";
import { HeaderSideComponent } from "./components/header-side/header-side.component";
import { SidebarSideComponent } from "./components/sidebar-side/sidebar-side.component";
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { AuthInterceptor } from "./services/auth.interceptor";
import { FooterComponent } from "./components/footer/footer.component";
import { ChatService } from "./services/chat.service";
import { WhatsappModule } from "./components/chat/whatsapp/whatsapp.module";
import { GenService } from "app/views/painel/gen-agreement/gen.service";
import { ModalService } from "./services/components/modal/modal.service";
import { AppContractsComponent } from "./services/app-contracts/app-contracts.component";
import { AppCodeConfirmComponent } from "./services/app-code-confirm/app-code-confirm.component";
import { AppCodeConfirmService } from "./services/app-code-confirm/app-code-confirm.service";

const classesToInclude = [
  AdminLayoutComponent,
  AuthLayoutComponent,
  ChatComponent,
  FontSizeDirective,
  ScrollToDirective,
  AppDropdownDirective,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  RelativeTimePipe,
  ExcerptPipe,
  ContractsComponent,
  HeaderTopComponent,
  HeaderSideComponent,
  SidebarSideComponent,
  SidenavComponent,
  FooterComponent,
  AppContractsComponent,
  AppCodeConfirmComponent,
];

@NgModule({
  imports: [
    PerfectScrollbarModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    RouterModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatListModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatTabsModule,
    MatTableModule,
    MatProgressBarModule,
    MatInputModule,
    MatTooltipModule,
    MatOptionModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    AppLoaderModule,
    AppConfirmModule,
    WhatsappModule,
    AuthContractsModule,
    MatDialogModule,
  ],
  providers: [
    ThemeService,
    LayoutService,
    PainelService,
    NavigationService,
    RoutePartsService,
    ChatService,
    AuthGuard,
    HttpClient,
    GenService,
    ModalService,
    AppCodeConfirmService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  declarations: classesToInclude,
  exports: classesToInclude,
  entryComponents: [AppContractsComponent, AppCodeConfirmComponent],
})
export class SharedModule {}
